<div class="layout-wrapper" [ngClass]="containerClass">
    <div class="layout-content-wrapper">
        <app-topbar #appTopbar></app-topbar>
        <app-breadcrumb style="padding-top: 4rem; !important;"></app-breadcrumb>
        <app-update></app-update>

        <div class="layout-content" style="padding-top: 0 !important;">
            <ng-container [ngTemplateOutlet]="layoutService.submenuContent"></ng-container>
            <ng-container [ngTemplateOutlet]="layoutService.subsubmenuContent"></ng-container>
            <div class="layout-content-main">
                <ng-content select="[main-panel]"></ng-content>
            </div>
        </div>

        <app-footer></app-footer>
    </div>
    <app-search></app-search>
</div>

<app-background-task-progress
    (openTasks)="appTopbar.onBackgroundTasksClick()"
></app-background-task-progress>
